import { Box, Typography } from '@mui/material'
import useHelpDocuments from 'hooks/useHelpDocument/useHelpDocument'
import Markdown from 'markdown-to-jsx'
import { useMemo } from 'react'

export default function HelpSupport() {
    const { loadingContent, docs } = useHelpDocuments()

    const helpDoc = useMemo(() => docs.find((i) => i.category === 'help'), [
        docs,
    ])

    return (
        <Box marginTop={7} p={1}>
            {loadingContent ? (
                <Box>
                    <Typography align="center" padding={10}>
                        ..Loading
                    </Typography>
                </Box>
            ) : !helpDoc ? (
                <Box>
                    <Typography align="center" padding={10}>
                        Not found Content
                    </Typography>
                </Box>
            ) : (
                <Markdown
                    children={helpDoc.content}
                    options={{ forceBlock: true }}
                />
            )}
        </Box>
    )
}
